import { render, staticRenderFns } from "./EmailBackOffice.vue?vue&type=template&id=0ef0291f"
import script from "./EmailBackOffice.vue?vue&type=script&lang=js"
export * from "./EmailBackOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports